<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="innerPagesRight customScroll" *ngIf="!loading; else loader">

    <!-- <app-banner-profile [viewType]="2" [businessID]="userBusinessDetails['business']?.id"
    [image]="'assets/images/logo.png'"
    [title]="'Admin Panel'"></app-banner-profile> -->
    <div class="innerpageContentBox mb-5">
      <form class="businessValidationformBox mb-3 filterform" [formGroup]="filterForm">
        <div class="innerpageContent">
          <div class="row">
            <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Category</mat-label>
                  <mat-select multiple formControlName="productCategoryId" class="font-15">
                    <mat-option [value]="" *ngIf="categoryList.loading"><i>Loading ...</i></mat-option>
                    <mat-option *ngFor="let category of categoryList.response" [value]="category.id" >
                      {{ category.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <!-- <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Product Type </mat-label>
                  <mat-select formControlName="productTypeId" class="font-15" >
                    <mat-option [value]="" *ngIf="productTypes.loading"><i>Loading ...</i></mat-option>
                    <mat-option *ngFor="let prod of productTypes.response" [value]="prod.id">
                      {{ prod.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div> -->
            <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Business Name </mat-label>
                  <mat-select multiple formControlName="businessName" [(ngModel)]="selectedOption" #select>
                    <input matInput (input)="onSearchInput($event)" placeholder="Enter business name" #searchInput />

                    <mat-option
                    *ngIf="filteredOptions.length === 0" [value]="null" style="pointer-events: none;" class="no-checkbox"
                  >
                      No options found
                  </mat-option>
                    <mat-option
                      *ngFor="let prod of filteredOptions"
                      [value]="prod.business_name"
                    >
                      {{ prod.business_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3" *ngIf="!this.approvedOnly">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Status </mat-label>
                  <mat-select multiple formControlName="validationStatusId" class="font-15" >
                    <mat-option [value]="" *ngIf="productStatus.loading"><i>Loading ...</i></mat-option>
                    <mat-option *ngFor="let prod of productStatus.response" [value]="prod.id">
                      {{ prod.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 daterange">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label for="picker">Reg Date</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate class="font-14" (click)="picker.open()" readonly formControlName="dateFrom" placeholder="Start date">
                    <input matEndDate class="font-14" (click)="picker.open()" readonly formControlName="dateTo" placeholder="End date">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <div class="btnbx mt-5">
            <button type="button" class="btnThemeOutline blue me-3" (click)="resetFilter()">Reset</button>
            <button class="btnTheme red" (click)="handleFilter()">Search</button>
          </div>
        </div>
      </form>
      <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title"></h1>
        </div>
        <div class="btnGrpp">
            <div class="serchblk">
              <div class="searchInputbx">
                <input type="text" [value]="searchProduct" class="inputBox2" id="weburl" placeholder=""
                  (input)="searchProductOnChange($event)" />
                <div class="removeico" (click)="clearSearch()" *ngIf="searchProduct"><img
                    src="assets/images/removeRoundgrey.svg" alt="Remove"></div>
              </div>
          </div>
        </div>
      </div>

      <div class="admin-table">
        <div class="tableblock">
          <table class="adminPanel-table">
            <tr>
              <th>S.NO </th>
              <th>PRODUCT NAME</th>
              <th>PRODUCT DESCRIPTION</th>
              <th>CATEGORY</th>
              <th class="text-end">PRICE</th>
              <th>BUSINESS NAME</th>
              <th class="text-center">STATUS</th>
              <th class="text-center">PRODUCT STATUS</th>
              <th class="text-center">ACTIONS</th>
            </tr>
            <div class="text-center" *ngIf="this.loading">
              <div class="loader"></div>
            </div>
            <ng-container *ngIf="!loading && products.length; else showEmptyView">
              <tr *ngFor="
              let product of products index as i">
                <td class="text-center">
                  <div class="serielNo">
                    {{ i + 1 + this.pageLimit * (this.currentPage - 1) }}</div>
                </td>
                <td>

                      <div class="d-blocl">{{ product.name }}</div>
                </td>
                <td>
                  <p class="description d-blocl" [innerHtml]="product.description"> </p>
                  <!-- <div class="viewbbtn" *ngIf="getProductShortDescription(product.description)"
                    (click)="showProductDescription(product.description)">Read more</div> -->
                </td>
                <td><p class="d-blocl">{{ product.categories }}</p></td>
                <td class="text-end">
                  <div class="prodlist-prises align-items-end">
                    <p class="prod-mrp text-end">MRP</p>
                    <P class="prod-prise text-end" *ngIf="product.price"> ₹ {{ product.price }}</P>
                    <ng-container *ngIf="product.discounted_price">
                    <p class="prod-mrp text-end">HSP</p>
                    <P class="prod-prise text-end"> ₹ {{ product.discounted_price }}</P>
                  </ng-container>
                  </div>
                </td>
                <td class="text-start">
                  <div class="prodListQty"> {{ product.businessName }}</div>
                </td>
                <td class="text-center">
                  {{ product?.status || "" }}
                </td>
                <td class="text-center">
                  <div class="document-acceptence" [style.pointer-events] = "statusLoading !== 0 ? 'none' : ''">
                    <label class="switch" (click)="handleStatus($event, product)" *ngIf="statusLoading !== product.productId">
                      <input type="checkbox" id="togBtn" checked *ngIf="this.showStatus(product)"/>
                      <input type="checkbox" id="togBtn" *ngIf="!this.showStatus(product)"/>
                      <div class="slider round">
                        <span class="on">Active</span>
                        <span class="off">Inactive</span>
                      </div>
                    </label>
                  </div>
                  <div class="loader small" *ngIf="statusLoading === product.productId"></div>
                </td>
                <td class="text-center">
                  <div class="actions">
                    <button class="action" *ngIf="!this.approvedOnly" (click)="this.showProductDetails(product.productId)">
                      <img src="./assets/images/eye-line.svg" alt="" />
                    </button>
                    <button class="action" (click)="this.showEditProductCard = product.productId">
                      <img src="./assets/images/edit-icon.svg" alt="" />
                    </button>
                  </div>
                </td>

              </tr>
            </ng-container>
          </table>
        </div>
      </div>


      <app-pagination *ngIf="!this.loading" class="mt-4 d-block" [currentPage]="currentPage" [totalItems]="totalRecords"
        [itemsPerPage]="pageLimit" (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"></app-pagination>
    </div>
  </div>
  <c-modal id="descripton-pop" [visible]="showDescription" backdrop="static" class="appModel productListmodel"
    alignment="center">
    <div class="modelContentBox py-3 px-4" *ngIf="showDescription">
      <div class="modelheader mb-8">
        <!-- <button cButtonClose class="modelClose" (click)="showDescription = false"></button> -->
        <button (click)="showDescription = false">

      <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
        </button>
      </div>
      <div class="modelBOdy">
        <div [innerHtml]="description"></div>
      </div>
    </div>
  </c-modal>
  <c-modal id="deleteDocumet" [visible]="this.showDeleteProductModel !== 0" backdrop="static" class="appModel"
    alignment="center">
    <div class="modelContentBox py-3 px-4" *ngIf="showDeleteProductModel !==0">
      <div class="modelheader mb-3">
        <!-- <button (click)="this.showDeleteProductModel = 0" cButtonClose class="modelClose"></button> -->
        <button (click)="this.showDeleteProductModel = 0">

      <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
        </button>
      </div>
      <div class="modelBOdy">
        <div class="msgCont">
          <!-- <img src="./assets/images/checkmark.svg" alt=""> -->
          <p class="delmsg">Are you sure you want to delete?</p>
          <div class="btngr">
            <button type="button" (click)="this.showDeleteProductModel = 0" class="btnThemeOutline blue">No</button>
            <button type="button" class="btnTheme red" (click)="this.handleProductDelete()">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </c-modal>
  <!-- add product popup start -->
  <c-modal id="addProductDetails" [visible]="this.showAddProductCard" *ngIf="this.showAddProductCard" class="addpro"
    alignment="center" size="xl">
    <div class="modelContentBox py-3 px-4">
      <div class="modelheader mb-8">
        <!-- <button cButtonClose class="modelClose" (click)="this.handleAddProduct(false);"></button> -->
        <button (click)="this.handleAddProduct(false);">

      <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
        </button>
      </div>
      <div class="modelBOdy">
        <app-add-local-business-product [formTitle]="title2" (resetListing)="this.resetListing()"
          (close)="this.handleAddProduct(false)"></app-add-local-business-product>
      </div>
    </div>
  </c-modal>
  <!-- add product popup end -->


  <!-- edit product popup start -->
  <c-modal id="editProductDetails" backdrop="static" [visible]="this.showEditProductCard !== 0" *ngIf="this.showEditProductCard !== 0"
    class="addpro" alignment="center" size="xl">
    <div class="modelheader mb-8">
      <button class="modelClose" (click)="this.handleEditProduct(0);">
        <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
      </button>
    </div>
    <div class="modelContentBox py-3 px-4">
      <div class="modelBOdy">
        <app-edit-local-business-product [formTitle]="title3" [selectedProductId]="this.showEditProductCard"
          (resetListing)="this.resetEditListing()"
          (close)="this.handleEditProduct(0)"></app-edit-local-business-product>
      </div>
    </div>
  </c-modal>
  <!-- edit product popup end -->


  <!-- show product details popup start-->
  <c-modal id="productDetails" [visible]="this.showDetails" backdrop="static" class="addpro" alignment="center"
    size="xl">
    <div class="modelheader mb-8">
      <!-- <button cButtonClose class="modelClose" (click)="this.showDetails = false"></button> -->
      <button class="modelClose" (click)="this.showDetails = false">
        <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
      </button>
    </div>
    <div class="modelContentBox py-3 px-4" *ngIf="preview == 0">
      <div class="text-center" *ngIf="this.productDetails.loading">
        <div class="loader"></div>
      </div>

      <div class="themeAlert danger" *ngIf="this.productDetails.error">
        {{this.productDetails.error}}
      </div>
      <div class="modelBOdy" *ngIf="!this.productDetails.loading && !this.productDetails.error">
        <form>
          <div class="frmbbxx">
            <!-- <div class="loader"></div> -->
            <app-main-heading [title]="productDetailsTitle"></app-main-heading>
            <div class="productPoup1">
              <div class="row">
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <input type="text" class="inputBox" id="productName"
                      [value]="this.productDetails?.response?.productName || ''" readonly />
                    <label for="productName" class="inputLabel popInLabel">Product name</label>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Category </mat-label>
                      <input matInput [value]="this.productDetails.response?.categoryName || ''" readonly />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Sub Category </mat-label>
                      <!-- <mat-select formControlName="productTypeId">
                        <mat-option>test1</mat-option>
                      </mat-select> -->
                      <input matInput [value]="this.productDetails.response?.subCategoryName || ''" readonly />

                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-8">
                  <div class="inputGroup">
                    <textarea placeholder="" class="inputBox regTextarea prodModelAreaheight addhtt" readonly
                      [value]="this.productDetails.response?.description || ''"></textarea>
                    <label for="addreg" class="inputLabel popInLabel">Write something...</label>
                  </div>
                  <!-- <span class="passError d-block text-start">Please write something </span> -->
                </div>
                <div class="col-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="inputGroup">
                        <input type="text" class="inputBox" id="sofylink" readonly
                          [value]="this.productDetails.response?.availableBranches.length ? this.selectedAvilableBranchesToShow(this.productDetails.response.availableBranches): ''"
                          placeholder="" />
                        <label for="sofylink" class="inputLabel popInLabel">Available branches</label>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="inputGroup">
                            <input [value]="this.productDetails.response?.weight || ''" class="inputBox" placeholder=""
                              readonly />
                            <label for="weight" class="inputLabel popInLabel">
                              Weight
                            </label>
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div class="inputGroup">
                            <mat-form-field class="w-100 mat-input-group" appearance="outline">
                              <mat-label class="matLabel">Weight Unit </mat-label>
                              <!-- <mat-select formControlName="productTypeId">
                                <mat-option>test1</mat-option>
                              </mat-select> -->
                              <input matInput [value]="this.productDetails.response?.weightUnit || ''" readonly />

                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Del. Distance </mat-label>
                      <input type="text" matInput readonly [value]="this.productDetails.response?.delDistance || ''">
                      <!-- <mat-select formControlName="delDistance">
                        <mat-option>test1</mat-option>
                      </mat-select> -->
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Product Type </mat-label>
                      <!-- <mat-select formControlName="productTypeId">
                        <mat-option>test1</mat-option>
                      </mat-select> -->
                      <input type="text" matInput readonly [value]="this.productDetails.response?.productType || ''">

                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Packing Type </mat-label>
                      <!-- <mat-select formControlName="packingTypeId">
                        <mat-option>test1</mat-option>
                      </mat-select> -->
                      <input type="text" matInput readonly [value]="this.productDetails.response?.packingType || ''">

                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="imgUploadTitle">Upload Product photo</div>
                  <div class="imageUploadSec" *ngIf="this.productDetails.response?.mediaList">
                    <div class="imageUpload me-2" *ngFor="let item of this.productDetails.response.mediaList">
                      <img src="{{item.src}}" (click)="onPreview(item.src, 1)"  class="width-110"alt="" />
                    </div>
                  </div>
                  <div class="imgUploadText">
                    *Recommended resolution is 640×640 with file size
                  </div>
                </div>
                <div class="tablebox" *ngIf="this.productDetails.response?.variantList.length">
                  <div class="addBlockpr customScroll">
                    <div class="addBlockprHead">
                      <div class="hedItm">S. No</div>
                      <div class="hedItm">SKU OR BARCODE or Variant name</div>
                      <div class="hedItm">Quantity</div>
                      <div class="hedItm">Stock Status</div>
                      <div class="hedItm">Status</div>
                      <div class="hedItm" *ngIf="this.productDetails.response.variantList[0]?.variantId1">Attribute 1</div>
                      <div class="hedItm" *ngIf="this.productDetails.response.variantList[0]?.variantId2">Attribute 2</div>
                      <div class="hedItm" *ngIf="this.productDetails.response.variantList[0]?.variantId3">Attribute 3</div>
                      <div class="hedItm">MRP</div>
                      <div class="hedItm">Discounted Price</div>
                      <div class="hedItm">Variant photo</div>
                    </div>
                    <div class="addrecRow" *ngFor="let item of this.productDetails.response.variantList; index as i;">
                      <div class="addrecItm">{{i+1}}</div>
                      <div class="addrecItm">
                        <div class="inputGroup w-100">
                          <input type="text" class="inputBox" id="sku" placeholder="" [value]="item.sku || ''"
                            readonly />
                          <label for="sku" class="inputLabel popInLabel">
                            SKU OR BARCODE
                          </label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                          <input type="text" [value]="item.quantity || ''" readonly class="inputBox" id="qult"
                            placeholder="" />
                          <label for="qult" class="inputLabel popInLabel">Quantity</label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                          <input type="text" matInput [value]="item.stockStatus || ''" readonly class="inputBox"
                            id="stksts" placeholder="" />
                          <label for="stksts" class="inputLabel popInLabel">Stock Status</label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                          <input type="text" matInput [value]="item.status || ''" readonly class="inputBox" id="sts"
                            placeholder="" />
                          <label for="sts" class="inputLabel popInLabel">Status</label>
                        </div>
                      </div>
                      <div class="addrecItm" *ngIf="item?.variantId1">
                        <div class="inputGroup">
                          <input type="text" matInput [value]="item.variantOption1 || ''" readonly class="inputBox"
                            id="variant" placeholder="" />
                          <label for="variant" class="inputLabel popInLabel">{{item.variantName1}}</label>
                        </div>
                      </div>
                      <div class="addrecItm" *ngIf="item?.variantId2">
                        <div class="inputGroup">
                          <input type="text" matInput [value]="item.variantOption2 || ''" readonly class="inputBox"
                            id="attr" placeholder="" />
                          <label for="attr" class="inputLabel popInLabel">{{item.variantName2}}</label>
                        </div>
                      </div>
                      <div class="addrecItm" *ngIf="item?.variantId3">
                        <div class="inputGroup">
                          <input type="text" matInput [value]="item.variantOption3 || ''" readonly class="inputBox"
                            id="attr" placeholder="" />
                          <label for="attr" class="inputLabel popInLabel">{{item.variantName3}}</label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                          <input type="text" [value]="item.price || ''" class="inputBox" id="mrp" placeholder=""
                            readonly />
                          <label for="mrp" class="inputLabel popInLabel">MRP
                          </label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                          <input type="text" [value]="item.discountedPrice || ''" class="inputBox" id="discounted"
                            placeholder="" style="width: 200px;" readonly />
                          <label for="discounted" class="inputLabel popInLabel">Discounted Price</label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="imageUploadSec" *ngIf="item?.mediaList">
                          <div class="imageUpload me-2 img-div-remove" *ngFor="let image of item.mediaList">
                            <img src="{{image.src}}"
                            style="width: 110px;"
                            (click)="onPreview(image.src, 1)"
                            (error)="setwidth($event)"
                             alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center d-block mb-2">
              <div class="btnbx modPopBtns mt-3" *ngIf="!(this.productDetails.response?.validationStatus === 'Approved')">
                <button class="btnThemeOutline blue me-3 modelPopup-btn" *ngIf="this.productDetails.response?.validationStatus === 'Rejected'"
                [style.opacity]="0.5" [style.cursor]="'not-allowed'">
                <span *ngIf="!rejectLoader">Reject</span>
                <div *ngIf="rejectLoader" class="small loader"></div>
              </button>
                <button class="btnThemeOutline blue me-3 modelPopup-btn" *ngIf="this.productDetails.response?.validationStatus !== 'Rejected'"
                  (click)="handleProductReject(this.productDetails.response.id)">
                  <span *ngIf="!rejectLoader">Reject</span>
                  <div *ngIf="rejectLoader" class="small loader"></div>
                </button>
                <button class="gredientOutLineBtn">
                  <div class="btnContent modelPopup-btn" (click)="handleProductApprove(this.productDetails.response.id)">
                    <span *ngIf="!approveLoader">Approve</span>
                    <div *ngIf="approveLoader" class="small loader"></div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="modelContentBox py-3 px-4  text-center" *ngIf="preview == 1">
      <div class=" mb-3" style="position: absolute;right: 17px;">
          <!-- <button (click)="onPreview('', 0)" cButtonClose class="modelClose"></button> -->
          <button cButtonClose (click)="onPreview('', 0)">
            <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
          </button>
      </div>
      <img id="blah" [src]="previewImg" style="width: 450px;border-radius: 10px;" alt="your image"/>
  </div>
  </c-modal>
  <!-- show product details popup end -->
</div>

<ng-template #showEmptyView>
  <tr *ngIf="!loading">
    <td colspan="9">
      <div class="nftd text-center p-4 d-block w-100">No Product found..</div>
    </td>
  </tr>
</ng-template>


<ng-template #loader>
  <div class="shimmertext">
    <span class="loader"></span>
  </div>
</ng-template>

<c-modal id="toggleErrorPopup" [visible]="this.toggleErrorPopup" backdrop="static" class="appModel"
alignment="center">
<div class="modelContentBox py-3 px-4 thankokpop">
  <div class="modelheader mb-3 thankokHeader">
    <!-- <button (click)="this.hideModel()" cButtonClose class="modelClose"></button> -->
    <button (click)="this.hideModel()">
      <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
    </button>
  </div>
  <div class="modelBOdy">
    <h4 class="thankokText">
      <img src="../../../assets/images/exclamation.png" />
    </h4>

    <div class="d-flex justify-content-center">
      <p class="mb-4">{{toggleErrorMsg}}</p>
    </div>
  </div>
</div>
</c-modal>
